import React, { Component } from 'react'
import _ from 'lodash'

import { getProjects } from '../../api/butterCMS'
import { Error404 } from '../../pages'
import { ContentBlock, MobileEmbed, DesktopEmbed, ProjectBullets, RelatedProjects } from '../../components'
import { Helmet } from 'react-helmet'
import { defaultAppTitle } from '../../config/functions'
import { LoadingSpinner } from '../../components/Global';
import TestimonialsScroller from '../../components/Testimonials/TestimonialsScroller'

class ProjectPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            project: false
        }
    }

    componentDidMount() {
        this.getProject()
    }

    componentDidUpdate(previousProps) {
        if ( !_.isEqual( previousProps.match.params, this.props.match.params ) ) {
            this.setState({
                isLoading: true
            })
            this.getProject()
        }
    }

    getProject() {
        const { slug } = this.props.match.params

        getProjects({ page_size: 1, 'fields.slug': slug }).then(({ data }) => {
            const { projects } = data
            const project = projects[0]

            this.setState({
                project,
                isLoading: false
            })

        }).catch(error => {
            this.setState({ 
                isLoading: false
            })
        })
    }


    render() {
        const { isLoading, project } = this.state

        if (isLoading) {
            return (
                <ContentBlock className="content-block content-block--page-loader">
                    <LoadingSpinner />
                </ContentBlock>
            )
        }

        if (!project) {
            return <Error404 />
        }

        return (
            <div>
                <Helmet>
                    <title>{`${project.title} // Work // ${defaultAppTitle}`}</title>
                    <meta name="description" content={project.introduction} />
                    <meta name="og:description" content={project.introduction} />
                    <link rel="stylesheet" href="/assets/css/prism.css" />
                    <script src="/assets/js/prism.js"></script>
                    <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {   
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Work",
                                "item": "https://davidwalker.info/work"
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name": "${project.title}",
                                "item": "https://davidwalker.info/work/${project.slug}"
                            }
                        ]
                    }
                    `}
                    </script>
                </Helmet>

                <ContentBlock className="content-block content-block--hero">
                    <h1 className="epsilon u-no-bm">
                        <a href={'/work'} className="u-unstyled">Work</a>
                        {` // ${project.title}`}
                    </h1>
                    <h2 className="alpha u-no-bm">{project.summary}</h2>
                </ContentBlock>

                <ContentBlock className="content-block content-block--fluid content-block--primary u-no-padding">
                    <ContentBlock className="content-block content-block--article">
                        <h3 className="beta u-margin--bottom-double">{project.introduction}</h3>
                        <ProjectBullets bullets={project.bullet_points} />
                    </ContentBlock>
                </ContentBlock>

                {project.desktop_demo_video ?
                    <DesktopEmbed bgImage={project.image} embedCode={project.desktop_demo_video} />
                : ''}

                {project.mobile_demo_video ?
                    <MobileEmbed bgImage={project.image} embedCode={project.mobile_demo_video} />
                : ''}

                {project.brief && project.result ?
                    <ContentBlock className="content-block content-block--article">
                        <div className="l-2-col">
                            <div className="l-col">
                                <h4 className="gamma">The brief</h4>
                                <div dangerouslySetInnerHTML={{ __html: project.brief }}></div>
                            </div>
                            <div className="l-col">
                                <h4 className="gamma">The result</h4>
                                <div dangerouslySetInnerHTML={{ __html: project.result }}></div>
                            </div>
                        </div>
                    </ContentBlock>
                : 
                    <div className="u-margin--bottom-double">
                        <br />
                    </div>
                }

                {project.html_content ?
                    <ContentBlock className="content-block content-block--article body-text" dangerouslySetInnerHTML={{ __html: project.html_content }}>
                    </ContentBlock>
                : ''}

                {project.testimonials ?
                    <TestimonialsScroller testimonials={project.testimonials} />
                : ''}

                {project.html_lower_content ?
                    <ContentBlock className="content-block content-block--article body-text" dangerouslySetInnerHTML={{ __html: project.html_lower_content }}>
                    </ContentBlock>
                : ''}

                <ContentBlock className="content-block content-block--fluid content-block--primary u-text-center u-no-padding--y-only">
                    <ContentBlock className="content-block u-no-padding--x-only">
                        <h5 className="beta u-margin--bottom-double u-text-notransform">
                            Would you like more proof? <br />
                            Check out these other projects...
                        </h5>
                    </ContentBlock>
                    <RelatedProjects originProject={project} />
                </ContentBlock>

            </div>
        )
    }
}

export default ProjectPage


// WEBPACK FOOTER //
// ./src/pages/projects/detail.js